import { useEffect, useRef, useState } from 'react';
import { getCourseCompletePercentage } from '../services/user/course';

export default function useCourseCardProgress(courseIds) {
  const [progressById, setProgressById] = useState({});
  const [refresh, setRefresh] = useState(0);
  const requests = useRef(new Map());
  const idsKey = [...new Set(courseIds.filter((id) => id != null).map(String))].sort().join(',');

  useEffect(() => {
    const reload = () => setRefresh((current) => current + 1);
    window.addEventListener('focus', reload);
    return () => window.removeEventListener('focus', reload);
  }, []);

  useEffect(() => {
    let active = true;
    const ids = idsKey ? idsKey.split(',') : [];

    const loadProgress = (id) => {
      const cached = requests.current.get(id);
      if (cached?.refresh === refresh) return cached.promise;

      const promise = getCourseCompletePercentage(id)
        .then((response) => {
          const value = response?.data?.overallCompletionPercentage;
          const percentage = value == null || value === '' ? NaN : Number(value);
          if (!response?.success || !Number.isFinite(percentage)) {
            return { status: 'error', percentage: null, completed: false };
          }
          return {
            status: 'ready',
            percentage: Math.min(100, Math.max(0, percentage)),
            completed: response.data.is_completed === true || Number(response.data.is_completed) === 1,
          };
        })
        .catch(() => ({ status: 'error', percentage: null, completed: false }));
      requests.current.set(id, { refresh, promise });
      return promise;
    };

    Promise.all(ids.map(async (id) => [id, await loadProgress(id)]))
      .then((entries) => {
        if (active) {
          setProgressById((current) => ({ ...current, ...Object.fromEntries(entries) }));
        }
      });

    return () => { active = false; };
  }, [idsKey, refresh]);

  return progressById;
}
